exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".slider--XjPf4 {\n\tpadding-bottom: 20px;\n}", ""]);

// Exports
exports.locals = {
	"slider": "slider--XjPf4"
};